import { render, staticRenderFns } from "./ProductQuantity.vue?vue&type=template&id=f8bb2d92&scoped=true&"
import script from "./ProductQuantity.vue?vue&type=script&lang=js&"
export * from "./ProductQuantity.vue?vue&type=script&lang=js&"
import style0 from "./ProductQuantity.vue?vue&type=style&index=0&id=f8bb2d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb2d92",
  null
  
)

export default component.exports